import React from 'react';

export const TagSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 16 17" fill={color} xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M8.27185 0.707031C7.54781 0.707031 6.85342 0.994656 6.34144 1.50663L0.799598 7.04848C-0.266533 8.11461 -0.266532 9.84315 0.799599 10.9093L5.21064 15.3203C6.27677 16.3865 8.00532 16.3865 9.07145 15.3203L14.6133 9.77848C15.1253 9.2665 15.4129 8.57212 15.4129 7.84808V3.43703C15.4129 1.92929 14.1906 0.707031 12.6829 0.707031H8.27185ZM12.2747 4.8152C12.9906 4.8152 13.571 4.23481 13.571 3.51886C13.571 2.80291 12.9906 2.22251 12.2747 2.22251C11.5587 2.22251 10.9783 2.80291 10.9783 3.51886C10.9783 4.23481 11.5587 4.8152 12.2747 4.8152Z" />
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 16 17" fill="#122D34" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.27185 0.707031C7.54781 0.707031 6.85342 0.994656 6.34144 1.50663L0.799598 7.04848C-0.266533 8.11461 -0.266532 9.84315 0.799599 10.9093L5.21064 15.3203C6.27677 16.3865 8.00532 16.3865 9.07145 15.3203L14.6133 9.77848C15.1253 9.2665 15.4129 8.57212 15.4129 7.84808V3.43703C15.4129 1.92929 14.1906 0.707031 12.6829 0.707031H8.27185ZM12.2747 4.8152C12.9906 4.8152 13.571 4.23481 13.571 3.51886C13.571 2.80291 12.9906 2.22251 12.2747 2.22251C11.5587 2.22251 10.9783 2.80291 10.9783 3.51886C10.9783 4.23481 11.5587 4.8152 12.2747 4.8152Z" />
    </svg>
  )
}